<template>
  <div>
    <form
      class="needs-validation"
      novalidate
      ref="form"
      v-on:submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col-12">
          <div class="">
            <label for="cardHolderName" class="form-label"
              >Card Holder Name (Name on card)</label
            >
            <input
              type="text"
              class="form-control"
              id="cardHolderName"
              required
              v-model="cardHolder"
              maxlength="50"
            />
            <div class="invalid-feedback">Please provide card holder name.</div>
          </div>
        </div>
        <div class="col-12">
          <div class="">
            <label for="cardNo" class="form-label">Card Number</label>
            <input
              type="text"
              class="form-control"
              id="cardNo"
              v-model="cardNo"
              required
              v-mask="'#### - #### - #### - ####'"
            />
            <div class="invalid-feedback">Please provide card number.</div>
          </div>
        </div>
        <div class="col-6">
          <div class="">
            <label for="cardExpires" class="form-label"
              >Expiration (MM/YY)</label
            >
            <input
              type="text"
              class="form-control"
              id="cardExpires"
              v-model="cardExpires"
              required
              maxlength="5"
              v-mask="'##/##'"
            />
            <div class="invalid-feedback">Please provide card expiration.</div>
          </div>
        </div>
        <div class="col-6">
          <div class="">
            <label for="cardSecurityCode" class="form-label"
              >Security Code</label
            >
            <input
              type="text"
              class="form-control"
              id="cardSecurityCode"
              v-model="cardSecure"
              required
              maxlength="3"
            />
            <div class="invalid-feedback">Please provide security code.</div>
            <div id="emailHelp" class="form-text text-info">
              <b-link @click="showGuideSecureCode" id="secureCodeGuideIcon">
                What is security code
                <b-icon class="ml-1" icon="question-circle"></b-icon>
              </b-link>

              <b-popover :target="`secureCodeGuideIcon`" :placement="'bottom'">
                3 digits number on the back of your credit card
                <div class="pt-2">
                  <b-img
                    v-bind="{ height: 48, width: 'auto' }"
                    src="~@/assets/imgs/secure-code.png"
                  ></b-img>
                </div>
              </b-popover>
            </div>
          </div>
        </div>
      </div>
      <button
        type="submit"
        ref="btnSubmit"
        style="width:0px: height:0px;position:absolute"
      ></button>
    </form>
  </div>
</template>

<script>
import { PlusIcon } from "vue-feather-icons";
export default {
  components: {
    PlusIcon,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    forceSave: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    cardHolder: "",
    cardNo: "",
    cardExpires: "",
    cardSecure: "",
  }),
  methods: {
    showGuideSecureCode() {},
    submitForm() {
      // do nothing
      //   console.log(this.$refs.form.checkValidity());
      //   if (this.$refs.form.checkValidity()) {
      //   }
      this.$refs.form.classList.add("was-validated");
    },
    validateForm() {
      this.$refs.btnSubmit.click();
      return this.$refs.form.checkValidity();
    },
    getCardInfo() {
      let valid = this.validateForm();
      if (!valid) return null;

      return {
        holderName: this.cardHolder,
        cardNo: this.cardNo,
        expires: this.cardExpires,
        secureCode: this.cardSecure,
      };
    },
    clear() {
      this.cardHolder = "";
      this.cardNo = "";
      this.cardExpires = "";
      this.cardSecure = "";
      this.$refs.form.classList.remove("was-validated");
    },
  },
};
</script>